module.exports = __webpack_public_path__ + "img/破涕为笑.5ddfcf41.png";